module.exports = __webpack_public_path__ + "static/media/logo.bf08f192.svg";